import { Roles } from 'consts/authConsts'
import useAccountOwnerId from 'hooks/useAccountOwnerId'
import useQueryParams from 'hooks/useQueryParams'
import { isUserOfRole } from 'utils/authUtils'

export default () => {
  const { queryParams } = useQueryParams()
  const isInternalUser = isUserOfRole([Roles.DevAdmin, Roles.HI, Roles.HIAdmin, Roles.Sales, Roles.Admin])

  const fallbackAccountOwnerId = useAccountOwnerId()
  const accountOwnerId =
    isInternalUser && queryParams.copilotDoctorId ? queryParams.copilotDoctorId : fallbackAccountOwnerId

  return accountOwnerId
}
